// Terms & Conditions by region. Sydney + Melbourne use AU; Auckland uses NZ.

var CLAIM_EVIDENCE_ITEMS = [
  'Ownership',
  'Item value (e.g. receipt or appraisal)',
  'The condition of the item prior to storage'
]

export var TERMS_AU = [
  'Valid photo identification is a requirement when using Secure Travel Storage Services.',
  'All items to be stored will be subject to security checks, physical inspection and/or explosive trace detection (ETD) screening by Baggage Storage by Secure Travel or the relevant security, local or federal, patrolling agencies at our locations.',
  'A 20 minute grace period applies past the original pickup time nominated during drop-off. Additional storage fees may be applicable for storage past the original pickup time nominated during drop-off. These additional fees require payment before items will be released.',
  'Refunds do not apply for early pick-ups, flight cancellations, delays, change of mind and/or events beyond the control of Baggage Storage by Secure Travel.',
  'All items not collected within 30 days of nominated pickup time and date will be treated as \'uncollected or abandoned goods\' and disposed of in line with relevant legislation and location guidelines.',
  'Baggage Storage by Secure Travel is committed to providing services with due care and skill in accordance with the Australian Consumer Law (ACL). Nothing in these Terms and Conditions excludes, restricts or modifies any rights or remedies you may have under the ACL or any other applicable law that cannot be excluded, restricted, or modified by agreement.',
  'To the extent permitted by law, we are not liable for loss or damage to items of extraordinary value, including (but not limited to) cash, jewellery, electronic equipment, valuable documents, fragile or perishable goods, unless such items were declared in writing and accepted by us at the time of storage.',
  {
    text: 'If an incident occurs where we are found to be at fault (for example, through proven negligence, theft, or fire while the items are in our care), a claim may be submitted. All claims will be subject to an internal investigation, and may require the customer to provide satisfactory evidence of:',
    subItems: CLAIM_EVIDENCE_ITEMS
  },
  'We reserve the right to reject claims that cannot be substantiated or where loss or damage is not attributable to our services.'
]

export var TERMS_NZ = [
  'Valid photo identification is a requirement when using Secure Travel Storage Services.',
  'All items to be stored will be subject to security checks, physical inspection and/or explosive trace detection (ETD) screening by Baggage Storage by Secure Travel or the relevant security, local or federal, patrolling agencies at our locations.',
  'A 20 minute grace period applies past the original pickup time nominated during drop-off. Additional storage fees may be applicable for storage past the original pickup time nominated during drop-off. These additional fees require payment before items will be released.',
  'Refunds do not apply for early pick-ups, flight cancellations, delays, change of mind and/or events beyond the control of Baggage Storage by Secure Travel.',
  'All items not collected within 30 days of nominated pickup time and date will be treated as \'uncollected or abandoned goods\' and disposed of in line with relevant legislation and location guidelines.',
  'Baggage Storage by Secure Travel is committed to providing services with due care and skill in accordance with the New Zealand Consumer Guarantee Act (CGA). Nothing in these Terms and Conditions excludes, restricts or modifies any rights or remedies you may have under the CGA or any other applicable law that cannot be excluded, restricted, or modified by agreement.',
  'To the extent permitted by law, we are not liable for loss or damage to items of extraordinary value, including (but not limited to) cash, jewellery, electronic equipment, valuable documents, fragile or perishable goods, unless such items were declared in writing and accepted by us at the time of storage.',
  {
    text: 'If an incident occurs where we are found to be at fault (for example, through proven negligence, theft, or fire while the items are in our care), a claim may be submitted. All claims will be subject to an internal investigation, and may require the customer to provide satisfactory evidence of:',
    subItems: CLAIM_EVIDENCE_ITEMS
  },
  'We reserve the right to reject claims that cannot be substantiated or where loss or damage is not attributable to our services.'
]

function normalizeName (value) {
  return String(value || '').trim().toLowerCase()
}

export function resolveTermsItems (storeId, stores) {
  var list = Array.isArray(stores) ? stores : []
  var store = list.find(function (row) {
    return Number(row.id) === Number(storeId)
  })
  var name = normalizeName(store && store.name)

  if (name.indexOf('auckland') >= 0) {
    return TERMS_NZ
  }

  if (name.indexOf('sydney') >= 0 || name.indexOf('melbourne') >= 0) {
    return TERMS_AU
  }

  return TERMS_AU
}



// WEBPACK FOOTER //
// ./src/constants/termsContent.js